import FolderCard from './FolderCard';
export default FolderCard;
